import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { ScreenLink, useScreenState } from '@gogame/screens';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeList,
  AttributeItem,
} from 'scenes/Gallery/components/AttributeList';
import { CONCEPT_ID } from 'scenes/Gallery/GalleryPage/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';
import { conceptPreviewLink } from 'scenes/Gallery/GalleryPage/navigation';

const DetailsColumn = ({ row }) => {
  const screenState = useScreenState();
  const { isAllowSharedWith, isAllowExclusiveForAffiliates } =
    useGalleryPermissions();
  const {
    [CONCEPT.ID]: id,
    [CONCEPT.NAME]: name,
    [CONCEPT.CREATIVES_COUNT]: creativesCount,
    [CONCEPT.ORIGINAL]: {
      [CREATIVE.CREATIVE_TYPE]: originalCreativeType,
      [CREATIVE.AI_GENERATED]: originalAIGenerated,
    },
    [CONCEPT.APPLICATIONS]: applications,
    [CONCEPT.EXCLUSIVE_FOR_AFFILIATES]: exclusiveForAffiliates,
    [CONCEPT.IS_NEW]: isNew,
    [CONCEPT.IS_PARTIAL_SHARED]: isPartialShared,
    [CONCEPT.IS_SHARED]: isShared,
    [CONCEPT.EXPIRATION_DATE]: expirationDate,
  } = row;

  const applicationsList = applications?.join(', ');

  return (
    <Stack spacing={0.5} zeroMinWidth={true}>
      <Typography variant={'body2'} noWrap={true}>
        <ScreenLink
          data-cy={'Concept Page'}
          link={conceptPreviewLink}
          pathParams={{
            [CONCEPT_ID]: id,
          }}
          searchParams={{
            filters: screenState.filters,
            creatives: {
              tableSettings: {
                orderDir: 'asc',
              },
            },
          }}
          underline={'always'}
          style={{
            minWidth: 0,
          }}
        >
          {name}
        </ScreenLink>
      </Typography>

      <Typography variant={'caption'} noWrap={true} component={'div'}>
        {applicationsList}
      </Typography>

      <Stack spacing={1} direction={'row'} alignItems={'center'}>
        <AttributeList type={'text'} listSeparator={'|'}>
          <AttributeItem valueParser={'variantsCount'} value={creativesCount} />
          <AttributeItem
            valueParser={'creativeType'}
            value={originalCreativeType}
          />
        </AttributeList>
        <AttributeList type={'icon'}>
          {exclusiveForAffiliates.length && isAllowExclusiveForAffiliates ? (
            <AttributeItem valueParser={'exclusiveForAffiliates'} />
          ) : null}
          {originalAIGenerated ? (
            <AttributeItem valueParser={'aiGenerated'} />
          ) : null}
          {expirationDate ? (
            <AttributeItem
              value={expirationDate}
              valueParser={'expirationDate'}
            />
          ) : null}
          {isPartialShared && isAllowSharedWith ? (
            <AttributeItem
              key={'partialShared'}
              valueParser={'partialShared'}
            />
          ) : isShared && isAllowSharedWith ? (
            <AttributeItem key={'shared'} valueParser={'shared'} />
          ) : null}
          {isNew ? <AttributeItem valueParser={'new'} /> : null}
        </AttributeList>
      </Stack>
    </Stack>
  );
};

export default DetailsColumn;
